import React from 'react';
import Image from 'next/image';
import { useTranslation } from 'next-i18next';

const SchoolGetStartedStepFive = () => {
  const { t } = useTranslation('common');
  return (
    <div className="school-section">
      <div className="grid grid-cols-12 gap-4">
        <div className="col-span-12 lg:col-span-5 md:col-span-6 hidden sm:block">
          <Image
            width={1478}
            height={618}
            sizes="100vw"
            style={{ width: '100%', height: 'auto' }}
            className="flex-image"
            src="/images/pron_list.png"
            alt="Pronunciation Image"
          />
        </div>
        <div className="col-span-12 lg:col-span-7 md:col-span-6">
          <h2 className="school-section-title h3">
            {t('service.school.gettingStarted.explanations.title.step4')}
          </h2>
          <div className="block sm:hidden my-8 sm:my-0">
            <Image
              width={1478}
              height={618}
              sizes="100vw"
              style={{ width: '100%', height: 'auto' }}
              className="flex-image"
              src="/images/pron_list.png"
              alt="Pronunciation Symbols"
            />
          </div>
          <p className="school-section-description">
            {t('service.school.gettingStarted.explanations.detail.step4')}
          </p>
        </div>
      </div>
    </div>
  );
};

export default SchoolGetStartedStepFive;
